import { createContext, useContext, useState, ReactNode } from 'react';

interface EmbeddedModeContextType {
  isEmbeddedMode: boolean;
}

const EmbeddedModeContext = createContext<EmbeddedModeContextType | undefined>(undefined);

export const useEmbeddedMode = () => {
  const context = useContext(EmbeddedModeContext);
  if (!context) {
    throw new Error('useEmbeddedMode must be used within an EmbeddedModeProvider');
  }
  return context;
};

export const useIsEmbeddedMode = () => {
  const context = useContext(EmbeddedModeContext);
  return context?.isEmbeddedMode ?? false;
};

interface EmbeddedModeProviderProps {
  children: ReactNode;
}

export const EmbeddedModeProvider = ({ children }: EmbeddedModeProviderProps) => {
  const [isEmbeddedMode] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('embeddedMode') === 'true';
  });

  return (
    <EmbeddedModeContext.Provider
      value={{
        isEmbeddedMode,
      }}
    >
      {children}
    </EmbeddedModeContext.Provider>
  );
};
